import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Minimize2 = createReactComponent("Minimize2", ["svg", defaultAttributes, [["polyline", {
  points: "4 14 10 14 10 20",
  key: "18b7oj"
}], ["polyline", {
  points: "20 10 14 10 14 4",
  key: "jvrbid"
}], ["line", {
  x1: "14",
  y1: "10",
  x2: "21",
  y2: "3",
  key: "u5avic"
}], ["line", {
  x1: "3",
  y1: "21",
  x2: "10",
  y2: "14",
  key: "qskfes"
}]]]);
export default Minimize2;